import { Fade, Flex, Spacer, Text, useDisclosure } from '@chakra-ui/react'
import React from 'react'
import { FaAngleDown, FaAngleUp } from 'react-icons/fa'

import SidebarLink from './SidebarLink'
import SideBarFunctionButton from './SidebarFunctionButton'

const SidebarSection = ({ title, links = [], defaultOpen = false }) => {
  const { isOpen, onToggle } = useDisclosure({ defaultIsOpen: defaultOpen })

  return (
    <Flex direction={'column'} gap={1}>
      <Flex color="hsla(0,0%,100%,.6)" w="100%" p="2" onClick={onToggle} _hover={{ cursor: 'pointer' }}>
        <Text casing="uppercase" fontWeight="700" fontSize="xs">
          {title}
        </Text>
        <Spacer />
        {isOpen ? <FaAngleUp /> : <FaAngleDown />}
      </Flex>
      <Fade in={isOpen}>
        <Flex direction={'column'} gap={'1'} display={isOpen ? 'flex' : 'none'}>
          {links.map((link) => {
            if (link.path) {
              return (
                <SidebarLink
                  key={link.path}
                  name={link.name}
                  path={link.path}
                  icon={link.icon}
                  target={link.target}
                  onClick={() => link.handleLinkClick()}
                />
              )
            } else if (link.onClick) {
              return (
                <SideBarFunctionButton
                  key={link.name}
                  name={link.name}
                //  onClick={link.onClick}
                  icon={link.icon}
                  target={link.target}
                  onClick={() => link.handleLinkClick()}
                />
              )
            }
          })}
        </Flex>
      </Fade>
    </Flex>
  )
}

export default SidebarSection
